import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';
import { IConnectedApplicationSecretType } from '../types/ConnectedApplicationType';

export interface CreateConnectedApplicationSecretResult {
    connectedApplicationSecret: IConnectedApplicationSecretType;
}

function createConnectedApplicationsSecretRequestConfig(appId: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.14',
    httpMethod: 'POST',
    endpoint: 'connected-applications/' + appId + '/secrets/',
    serverWideRequest: false
  };
}

export function callCreateConnectedApplicationsSecret(appId: string): Promise<CreateConnectedApplicationSecretResult> {
  return makeJsonRestApiRequest<void, CreateConnectedApplicationSecretResult>({
    config: createConnectedApplicationsSecretRequestConfig(appId),
    request: null,
  });
}